// @flow strict

import * as React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';

type PropType = {|
  href: string,
  type: 'Facebook' | 'Twitter' | 'LinkedIn' | 'Email',
  color: 'Color' | 'Grey' | 'Black',
  className?: string,
|};

const SocialIcon = (props: PropType) => (
  <a
    href={props.href}
    className={cx(
      styles.socialLink,
      styles[`is${props.type}`],
      styles[`is${props.color}`],
      props.className,
    )}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className={styles.screenReaderText}>{props.type}</span>
  </a>
);

SocialIcon.defaultProps = {
  color: 'Black',
};

export default SocialIcon;
